module.exports = "<selectpopup\n    items=\"dealType.options\"\n    source=\"dealType.selectedOption\"\n    classes=\"filter__popup-trigger s-button_bright\"\n    on-change=\"dealType.changeType()\"\n    >\n</selectpopup>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/deal-type-browser/templates/deal-type-browser.html
// module id = 263
// module chunks = 0